module.exports = __webpack_public_path__ + "static/media/login_img.bd38942b.png";